import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ADPResourceService } from 'digital-core';
import { AccountService } from 'src/app/core/services/account.service';
import { LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { IFamilyMember } from 'src/app/model/contract/IContract';
import { UserClaims } from 'src/app/model/okta/userClaims';

@Component({
  selector: 'pgh-edit-member-details',
  templateUrl: './edit-member-details-modal.component.html',
  styleUrls: ['./edit-member-details-modal.component.scss'],
})
export class EditMemberDetailsModalComponent implements OnInit {
  familyMember: IFamilyMember;
  memberDetailsForm: UntypedFormGroup;
  loggedInUser: UserClaims;
  isSaving = false;
  validationError: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
    private dialogRef: MatDialogRef<EditMemberDetailsModalComponent>,
    private accountService: AccountService,
    private loggedInUserSettings: LoggedInUserSettings,
    private resourceService: ADPResourceService
  ) {}

  ngOnInit() {
    this.familyMember = this.dialogData.member;
    this.loggedInUser = this.dialogData.user;
    this.memberDetailsForm = new UntypedFormGroup({
      firstName: new UntypedFormControl(this.familyMember.firstName, [Validators.required, Validators.maxLength(30)]),
      lastName: new UntypedFormControl(this.familyMember.lastName, [Validators.required, Validators.maxLength(30)]),
      phoneNumber: new UntypedFormControl(this.familyMember.phoneNumber, [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(10),
      ]),
    });
  }

  onCancelClicked() {
    this.dialogRef.close({
      data: {
        result: 'failure',
      },
    });
  }

  onSaveClicked() {
    this.isSaving = true;
    this.familyMember.firstName = this.memberDetailsForm.get('firstName').value;
    this.familyMember.lastName = this.memberDetailsForm.get('lastName').value;
    this.familyMember.phoneNumber = this.memberDetailsForm.get('phoneNumber').value;
    // strip non numeric chars from phoneNumber.
    this.familyMember.phoneNumber = this.familyMember.phoneNumber.replace(/\D/g, '');
    this.loggedInUserSettings.clearContractFromCache();
    this.accountService
      .putEditMemberDetails(this.familyMember.contractNumber, this.familyMember.customerNumber, this.familyMember)
      .subscribe(() => {
        this.loggedInUserSettings.clearContractFromCache();
        this.dialogRef.close({
          data: {
            result: 'success',
          },
        });
      });
  }

  getResource(name: string, namespace = null) {
    namespace = namespace ? namespace : 'Account_Manage_Members_AddMember';
    let title = namespace + '_' + name;
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  isLetters(event): boolean {
    const iKeycode = event.keyCode;
    return (iKeycode >= 65 && iKeycode <= 90) || (iKeycode >= 97 && iKeycode <= 122) || iKeycode === 39;
  }

  validatePhoneNumber() {
    if (
      (this.memberDetailsForm.get('phoneNumber').touched && !this.memberDetailsForm.get('phoneNumber').dirty) ||
      !this.memberDetailsForm.get('phoneNumber').value
    ) {
      this.validateInputFieldRequired();
    } else {
      this.validateInputFieldFormat();
    }
  }

  validateInputFieldRequired() {
    this.validationError = !this.memberDetailsForm.get('phoneNumber').value
      ? this.resourceService.getViewLabel('Global_Error_Required_Phone_No')
      : undefined;
  }

  validateInputFieldFormat() {
    const optionValue = this.memberDetailsForm.get('phoneNumber').value;
    const isValid = !!(String(optionValue).length == 10);
    this.validationError = !isValid ? this.resourceService.getViewLabel('Global_Error_Valid_Phone_No') : undefined;
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
